import { ArrowDown, Phone } from "lucide-react";
import heroBg from "../assets/hero-bg.jpeg";

export function Hero() {
  return (
    <section id="home" className="relative h-screen min-h-[680px] flex flex-col justify-end overflow-hidden">
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="Electrical work — Power One Electric New Orleans"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-linear-to-b from-slate-900/60 via-slate-900/40 to-slate-900/90" />
        <div className="absolute inset-0 bg-linear-to-r from-slate-900/70 via-transparent to-transparent" />
      </div>

      {/* Content — bottom-left */}
      <div className="relative z-10 container mx-auto px-6 pb-24">
        <div className="max-w-3xl">

          <h1 className="hero-title text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[0.95] tracking-tight mb-6 shrink-0">
            Where<br />
            quality meets<br />
            power.
          </h1>

          <p className="hero-sub text-xl text-slate-300 max-w-xl mb-10 leading-relaxed">
            Commercial electrical solutions across Louisiana. Built on quality. Trusted since 2008.
          </p>

          <div className="hero-ctas flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 bg-[#2557C7] hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-black text-base transition-all duration-200 shadow-xl shadow-blue-900/40 hover:-translate-y-0.5"
            >
              Request a Free Quote
            </a>
            <a
              href="tel:5042872940"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-8 py-4 rounded-xl font-semibold text-base transition-all duration-200 backdrop-blur-sm"
            >
              <Phone className="h-4 w-4" />
              (504) 287-2940
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce opacity-60">
        <ArrowDown className="h-5 w-5 text-white" />
      </div>
    </section>
  );
}
